// extracted by mini-css-extract-plugin
module.exports = {"chat":"c6e8ba5398--chat--2sX0m"};